import { SecuredWsFrontendApi } from "@/utils/http-client-wp-frontend";
import { WsApi } from "@/utils/http-client";

export default {
  getListOfTerminals(accountMerchantId) {
    return SecuredWsFrontendApi.get(`/api/portal/Merchant/${accountMerchantId}/card-present-terminals`);
  },
  getTransactionReceipt(payload) {
    return WsApi.post(`/api/paymentflow/v1/transaction/transaction-receipt`, payload);
  },
  cancelCardPresentPayment(payload) {
    return WsApi.post("/api/paymentflow/v1/transaction/cancel-card-present-payment", payload);
  },
};
